<div class="container mt-4">
    <h3 class="mb-3">Reporte de Datos</h3>
  
    <form class="form-inline mb-3">
      <div class="form-group mr-3">
        <label for="nombre" class="mr-2">Nombre:</label>
        <input
          type="text"
          id="nombre"
          class="form-control"
          [(ngModel)]="filtros.FullName"
          name="nombre"          
        />
      </div>
  
      <div class="form-group mr-3">
        <label for="fechaInicio" class="mr-2">Desde:</label>
        <input
          type="date"
          id="fechaInicio"
          class="form-control"
          [(ngModel)]="filtros.FromDate"
          name="fechaInicio"
        />
      </div>
  
      <div class="form-group mr-3">
        <label for="fechaFin" class="mr-2">Hasta:</label>
        <input
          type="date"
          id="fechaFin"
          class="form-control"
          [(ngModel)]="filtros.ToDate"
          name="fechaFin"          
        />
      </div>

      <!-- 🔍 Botón Buscar -->
      <div class="form-group">
        <button type="button" class="btn btn-info" (click)="cargarAplicaciones()">
          Buscar
        </button>
      </div>
    </form>
  
    <div class="mb-3">
      <button class="btn btn-info mr-2" (click)="exportarExcel()">Exportar a Excel</button>
      <!-- <button class="btn btn-info" (click)="exportarPDF()">Exportar a PDF</button> -->
    </div>
  
    <table class="table table-bordered table-striped">
      <thead class="thead-dark">
        <tr>
          <th>Nombre</th>
          <th>Phone</th>
          <th>Correo</th>
          <th>College</th>
          <th>Documents</th>
          <th>Fecha</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of datos">
          <td>{{ item.fullName }}</td>
          <td>{{ item.phone }}</td>
          <td>{{ item.email }}</td>
          <td>{{ item.college }}</td>
          <td>
            <div class="document-list">
              <a *ngFor="let doc of item.documents || []" 
                 [href]="getDownloadUrl(doc.id)" 
                 target="_blank" 
                 class="document-item"
                 [title]="doc.fileName">
                <span class="material-icons">description</span> <!-- Ícono de documento -->
                <!-- {{ doc.id | slice:0:8 }} -->
              </a>
              <span *ngIf="!item.documents?.length">Sin documentos</span>
            </div>
          </td>
          <td>{{ item.createdAt }}</td>
        </tr>
        <tr *ngIf="datos.length === 0">
          <td colspan="6" class="text-center">No hay resultados</td>
        </tr>        
      </tbody>
    </table>
    <!-- <div class="spinner"></div> -->
  </div>